export function convertDocument<T>(doc) {
  return <T> {
    ...doc.data()
  };
}

export function convertDocumentSnap<T>(snap) {
  return <T> {
    id: snap.payload.id,
    ...snap.payload.data()
  };
}

export function convertSnaps<T>(snaps) {
  return <T[]> snaps.map(snap => {
    return {
      id: snap.payload.doc.id,
      ...snap.payload.doc.data()
    };
  });
}
